import { jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { Root } from "./Root.js";
import { useStyles } from "./useStyles.js";
function SuperCarIndicator(props) {
  const { size, duration, color } = props;
  const theme = useTheme();
  const styles = useStyles({
    size,
    duration,
    color: color ?? (theme.vars ?? theme).palette.primary.main
  });
  return /* @__PURE__ */ jsx(Root, { style: styles.root });
}
export {
  SuperCarIndicator
};
//# sourceMappingURL=SuperCarIndicator.js.map
